import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Ecosystem = () => {
  const pillars = [
    {
      title: "DKT Token",
      desc: "The blockchain-powered utility asset connecting all ecosystem participants.",
      icon: "Zap",
      color: "from-purple-500/20 to-transparent",
      border: "border-purple-500/30"
    },
    {
      title: "DKL Streetwear",
      desc: "Spiritually inspired lifestyle brand focused on self-expression and growth.",
      icon: "ShoppingBag",
      color: "from-pink-500/20 to-transparent",
      border: "border-pink-500/30"
    },
    {
      title: "Reiki Services",
      desc: "Energy-healing services operating under the DAI KHO brand universe.",
      icon: "Activity",
      color: "from-cyan-500/20 to-transparent",
      border: "border-cyan-500/30"
    }
  ];

  return (
    <section className="py-32 px-4 bg-[#05001a]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-7xl font-black mb-6">The <span className="text-gradient">Trident</span> Pillars.</h2>
          <p className="text-slate-400 text-xl font-light">A self-reinforcing ecosystem blending digital, physical, and metaphysical.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {pillars.map((pillar, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -10 }}
              className={`p-10 rounded-[3rem] bg-[#0a0515] border ${pillar.border} relative overflow-hidden group transition-all duration-500`}
            >
              <div className={`absolute inset-0 bg-gradient-to-b ${pillar.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
              <div className="relative z-10">
                <div className="w-16 h-16 rounded-2xl bg-white/5 flex items-center justify-center mb-8 border border-white/10 group-hover:scale-110 transition-transform">
                  <SafeIcon name={pillar.icon} className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-3xl font-black mb-4 text-white uppercase tracking-tighter">{pillar.title}</h3>
                <p className="text-slate-400 leading-relaxed text-lg font-light">{pillar.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ecosystem;